<template>
  <div>
    <!-- top search bar -->
    <div class="pa-5 d-flex">
      <div class="form-input-group flex-grow-1 mr-5">
        <div class="prepend-icon" style="top: 45%;">
          <v-icon>search</v-icon>
        </div>
        <input
          type="text"
          class="pl-42px"
          placeholder="搜尋"
          v-model="textFilter"
        />
      </div>
      <SimpleSelectWithSearchInput
        class="mr-5"
        buttonPlaceholder="篩選年份"
        buttonWidth="140px"
        modalWidth="140px"
        :options="yearOptions"
        :selectedValue.sync="yearFilter"
      ></SimpleSelectWithSearchInput>
      <TableControlShowState v-model="showOrHide"></TableControlShowState>
      <button class="btn btn-primary w-88px">搜尋</button>
    </div>

    <!-- table -->
    <div class="table">
      <div class="table-head">
        <!-- column head -->
        <div
          v-if="lengthOfisCheckedList == 0"
          class="form-item d-flex px-5 h-60px align-center"
        >
          <h5 class="col-checkbox">
            <v-checkbox
              v-model="checkAllStatus"
              :indeterminate="indeterminate"
              @click="changeAllCheckbox"
            ></v-checkbox>
          </h5>
          <h5 class="col-date">Date</h5>
          <h5 class="col-news-title">News Title</h5>
          <h5 class="col-show ml-auto">顯示/隱藏</h5>
          <h5 class="col-edit">編輯</h5>
          <h5 class="col-delete">刪除</h5>
        </div>
        <!-- column action -->
        <div v-else class="form-item d-flex align-center px-5 h-60px">
          <h5 class="col-checkbox">
            <v-checkbox
              v-model="checkAllStatus"
              :indeterminate="indeterminate"
              @click="changeAllCheckbox"
            ></v-checkbox>
          </h5>
          <h5 class="mr-22px">{{ lengthOfisCheckedList }} 項已選取</h5>
          <div>
            <button
              class="btn btn-danger mr-10px"
              @click="deleteItems(selectedItems)"
            >
              <v-icon color="white" class="mr-2">delete</v-icon>
              <span>刪除</span>
            </button>
          </div>
          <div>
            <button
              class="btn mr-10px"
              @click="setItemsShowStatus(selectedItems, true)"
            >
              設為顯示
            </button>
          </div>
          <div>
            <button
              class="btn"
              @click="setItemsShowStatus(selectedItems, false)"
            >
              設為隱藏
            </button>
          </div>
        </div>
      </div>
      <div class="table-body">
        <div
          class="form-item d-flex h-60px align-center"
          v-for="item in filterNumPerPageTableList"
          :key="item.id"
        >
          <div class="h5 col-checkbox">
            <v-checkbox
              v-model="selectedItems"
              :value="item.id"
              :key="`checkbox-${item.id}`"
            ></v-checkbox>
          </div>
          <div class="h5 col-date">{{ stampToDate(item.date) }}</div>
          <div class="h5 col-news-title">{{ item.title }}</div>
          <div class="h5 col-show ml-auto d-flex align-center">
            <FormSwitch v-model="item.isShow"></FormSwitch>
          </div>
          <div class="h5 col-edit ">
            <button class="btn square" @click="editItem">
              <v-icon>edit</v-icon>
            </button>
          </div>
          <div class="h5 col-delete">
            <button class="btn square" @click="deleteItem(item.id)">
              <v-icon>delete</v-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- table footer -->
    <div class="d-flex justify-end align-center h5" style="padding: 26px 20px;">
      <!-- item per page -->
      <div class="mr-10px d-flex align-center">
        <span class="mr-10px">單頁顯示筆數</span>
        <TableNumPerPage
          v-model="numberOfItemsPerPage"
          @input="currentPage = 1"
        ></TableNumPerPage>
      </div>
      <!-- item total -->
      <div class="mr-10px">
        <span style="margin-right: 2px">{{ displayPageToPage() }}</span>
        <span>共 {{ filterTableList.length }}筆</span>
      </div>
      <!-- pre and next -->
      <div>
        <button class="btn square w-32px h-32px mr-4" @click="lastPage">
          <v-icon>navigate_before</v-icon>
        </button>
        <button class="btn square w-32px h-32px" @click="nextPage">
          <v-icon>navigate_next</v-icon>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleSelectWithSearchInput from '@/components/Selection/SimpleSelectWithSearchInput.vue';
import TableControlShowState from '@/components/TableControlShowState.vue';
import FormSwitch from '@/components/FormSwitch.vue';
import TableNumPerPage from '@/components/TableNumPerPage.vue';

export default {
  components: {
    SimpleSelectWithSearchInput,
    TableControlShowState,
    FormSwitch,
    TableNumPerPage,
  },
  data: () => ({
    // filter
    textFilter: '',
    checkAllStatus: false, // left top checkbox status
    yearFilter: '',
    showOrHide: 'nolimit', // top right fiter
    yearOptions: [...Array(100).keys()].map((i) => i + 1991),
    // selectedItems
    selectedItems: [],
    // table lsit
    tableList: [
      {
        id: '001',
        date: 1599729939722,
        title: '文章標題文章標題文章標題文章標題文章標題文章標題文章標',
        isShow: true,
      },
      {
        id: '002',
        date: 1590000000000,
        title:
          '文章標題文章標題文章標題文章標題文章標題文章標題文章標二二二二二二二二二二二',
        isShow: false,
      },
    ],
    numberOfItemsPerPage: '10', // at bottom table footer
    currentPage: 1,
  }),
  computed: {
    filterTableList() {
      const vm = this;

      return (
        this.tableList
          // textFilter
          .filter((item) => item.title.toLowerCase().includes(vm.textFilter))
          // showState
          .filter((item) => {
            if (vm.showOrHide === 'nolimit') {
              return true;
            }
            if (vm.showOrHide === 'show') {
              return item.isShow;
            }
            return !item.isShow;
          })
      );
    },
    filterNumPerPageTableList() {
      const vm = this;
      return this.filterTableList.filter((item, i) => {
        if (vm.numberOfItemsPerPage === 'All') return true;
        return (
          i <= Number(vm.numberOfItemsPerPage) * vm.currentPage - 1 &&
          i >= Number(vm.numberOfItemsPerPage) * (vm.currentPage - 1)
        );
      });
    },
    lengthOfisCheckedList() {
      return this.selectedItems.length;
    },
    indeterminate() {
      if (
        this.lengthOfisCheckedList === 0 ||
        this.lengthOfisCheckedList === this.filterNumPerPageTableList.length
      ) {
        return false;
      }
      return true;
    },
  },
  watch: {
    lengthOfisCheckedList(newValue) {
      if (newValue < this.filterNumPerPageTableList.length) {
        this.checkAllStatus = false;
      } else if (newValue === 0) {
        this.checkAllStatus = false;
      } else if (newValue === this.filterNumPerPageTableList.length) {
        this.checkAllStatus = true;
      }
    },
  },
  methods: {
    editItem() {
      this.$router.push('/sports-lottery/edit');
    },
    changeAllCheckbox() {
      if (this.checkAllStatus) {
        const allItemsInPage = this.filterNumPerPageTableList.map(
          (item) => item.id,
        );
        this.$set(this, 'selectedItems', allItemsInPage);
      } else {
        this.$set(this, 'selectedItems', []);
      }
    },
    deleteItem(itemId) {
      const index = this.tableList.findIndex(
        (listItem) => listItem.id === itemId,
      );
      this.tableList.splice(index, 1);

      const selectedIndex = this.selectedItems.findIndex((listItem) => {
        console.log(listItem, itemId);
        return listItem === itemId;
      });
      console.log('selectedIndex', selectedIndex);
      if (selectedIndex >= 0) {
        this.selectedItems.splice(selectedIndex, 1);
      }
    },
    deleteItems(itemIds) {
      console.log(itemIds);
      [...itemIds].forEach((itemId) => {
        this.deleteItem(itemId);
      });
    },
    setItemShowStatus(id, status) {
      this.tableList.find((item) => item.id === id).isShow = status;
    },
    setItemsShowStatus(items, status) {
      this.selectedItems.forEach((id) => this.setItemShowStatus(id, status));
    },
    lastPage() {
      if (this.currentPage === 1) {
        return;
      }
      this.currentPage -= 1;
    },
    nextPage() {
      if (this.numberOfItemsPerPage === 'All') return;
      if (
        this.currentPage * Number(this.numberOfItemsPerPage) >
        this.filterTableList.length
      ) {
        return;
      }
      this.currentPage += 1;
    },
    displayPageToPage() {
      let left;
      let right;

      const filterLength = this.filterTableList.length;
      const perPageLength = Number(this.numberOfItemsPerPage);

      if (this.numberOfItemsPerPage === 'All') {
        left = 1;
        right = filterLength;
      } else {
        left = 1 + perPageLength * (this.currentPage - 1);
        right = perPageLength * this.currentPage;
        if (perPageLength * this.currentPage > filterLength) {
          right = filterLength;
        }
      }

      return `${left}-${right}`;
    },
    stampToDate(stamp) {
      const dateObj = new Date(stamp);
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const date = String(dateObj.getDate()).padStart(2, '0');

      return `${year}/${month}/${date}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  .col-date {
    width: 75px;
    margin-right: 40px;
  }
  .col-news-title {
    width: 390px;
    margin-right: 50px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .col-tab {
    width: 130px;
    margin-right: 10px;
  }
  .col-show {
    margin: 0 20px;
  }
}
</style>
